import styled from 'styled-components';

export const Video = styled.video<{
  $round?: boolean;
  $isBestNft?: boolean;
}>`
  ${props =>
    props.$isBestNft
      ? `
        position: relative;
      `
      : `
        position: absolute;
  `};
  inset: 0;
  object-fit: cover;
  border-radius: ${props => (props.$round ? '20px' : '16px')};
`;
